import { XMarkIcon } from '@heroicons/react/16/solid';
import { LinkIcon } from '@heroicons/react/24/outline';
import { useState } from 'react';

import truncateString from 'src/shared/utils/truncateString';

import { Typography } from '../ui';
import { ButtonV2 } from '../ui';

interface LinkAttachmentProps {
  url?: string;
  caption?: string;
  onRemove?: () => void;
}

const LinkAttachment: React.FC<LinkAttachmentProps> = ({
  onRemove,
  url,
  caption
}) => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <div
      className="relative max-w-fit"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <ButtonV2
        onPress={() => {
          if (url) {
            window.open(url, '_blank');
          }
        }}
        className="p-1 pr-2 relative hover:bg-white min-w-36 justify-start"
        startContent={
          <div className="bg-gray-2 size-10 flex items-center justify-center rounded-xl">
            <LinkIcon className="size-5 text-primary" />
          </div>
        }
        size="xl"
        color="tertiary"
      >
        <div className="flex flex-col">
          <Typography variant="body-2" weight="medium">
            {url}
          </Typography>
          {caption && (
            <Typography
              variant="body-3"
              weight="medium"
              className="text-secondary-text text-left"
            >
              {truncateString(caption, 30)}
            </Typography>
          )}
        </div>
      </ButtonV2>

      {isHovered && onRemove && (
        <ButtonV2
          onPress={onRemove}
          size="xs"
          className="bg-black absolute -right-2 -top-2 w-5"
          isIconOnly
        >
          <XMarkIcon className="size-4 text-white" />
        </ButtonV2>
      )}
    </div>
  );
};

export default LinkAttachment;
